import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">关于我们</h2>
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mb-8">
            {aboutData.content}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.value}</div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}